export default __webpack_public_path__ + "static/media/hot-11.250a35b5.png";